import React from 'react'

export default function AdBannerSmall2() {
    return (
        <div className="col-lg-12 col-md-6 col-12">

            <div className="hero-small-banner style2">
                <div className="content">
                    <h2>Lorem ipsum dolor sit amet</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua.</p>
                    <div className="button">
                        <a className="btn btn-b btn-circle shopping-a" href="#">More Info</a>
                    </div>
                </div>
            </div>

        </div>
  )
}
